import { render, staticRenderFns } from "./TeacherCarousel.vue?vue&type=template&id=3bbb42d4&scoped=true&"
import script from "./TeacherCarousel.vue?vue&type=script&lang=js&"
export * from "./TeacherCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCarousel.vue?vue&type=style&index=0&id=3bbb42d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb42d4",
  null
  
)

export default component.exports